module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/twitter.svg?7863b639e5cc4b67dd0506605f9c6274";